import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GamificationPage } from './page/gamification.page';

const routes: Routes = [
  {
    path: '',
    component: GamificationPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GamificationRoutingModule { }
